import React from "react";
import { withRouter } from "react-router";
import LoginForm from "./login-form";
import LoginPageLayout from "./login-page-layout";
import getParameterByName from "../../../legacy/helpers/get_parameter_by_name";

const LoginPage = props => {
    const { location } = props;
    const search = location && location.search;
    const next = props.next || getParameterByName("next", search) || "/";

    return (
        <LoginPageLayout
            formSectionContent={<LoginForm next={next} showFacebookLoginLink />}
        />
    );
};

export const UnwrappedLoginPage = LoginPage;

export default withRouter(LoginPage);
